import React from 'react';
import PropTypes from 'prop-types';

function TableCell({ children, className, colSpan, rowSpan }) {
  return (
    <td
      colSpan={colSpan}
      rowSpan={rowSpan}
      className={`px-6 py-6 ${className || ''}`}
    >
      {children}
    </td>
  );
}

TableCell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  rowSpan: PropTypes.number,
};

export { TableCell };
